/* Shared JSON-LD builders (CommonJS so the React app and the build-time prerender use identical output). */
const cfg = require('./routes.config.json');

const SITE = cfg.siteUrl;
const b = cfg.business;
const orgId = `${SITE}/#organization`;
const personId = `${SITE}/#founder`;
const websiteId = `${SITE}/#website`;
const LANG_NAMES = { de: 'German', en: 'English', fr: 'French' };

const postalAddress = () => ({
  '@type': 'PostalAddress',
  streetAddress: b.streetAddress,
  postalCode: b.postalCode,
  addressLocality: b.locality,
  addressRegion: b.region,
  addressCountry: b.country,
});

// strings: { orgDescription, services: [], jobTitle }
function organizationSchema(strings) {
  return {
    '@type': 'ProfessionalService',
    '@id': orgId,
    name: b.name,
    alternateName: 'FlorentDev – Florent Bajraktari',
    url: SITE,
    logo: `${SITE}${b.logoPath}`,
    image: `${SITE}${b.logoPath}`,
    email: b.email,
    description: strings.orgDescription,
    founder: { '@id': personId },
    address: postalAddress(),
    hasMap: b.mapUrl,
    areaServed: [
      ...b.areaServed.map((name) => ({ '@type': 'City', name, containedInPlace: { '@type': 'AdministrativeArea', name: `Kanton ${b.regionName}` } })),
      { '@type': 'AdministrativeArea', name: `Kanton ${b.regionName}`, containedInPlace: { '@type': 'Country', name: 'Switzerland' } },
    ],
    knowsLanguage: cfg.langs.map((l) => LANG_NAMES[l]),
    availableLanguage: cfg.langs.map((l) => LANG_NAMES[l]),
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: b.email,
      availableLanguage: cfg.langs.map((l) => LANG_NAMES[l]),
      areaServed: 'CH',
    },
    priceRange: 'CHF',
    currenciesAccepted: 'CHF',
    sameAs: [b.mapUrl, b.linkedin],
    makesOffer: strings.services.map((name) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name, provider: { '@id': orgId }, areaServed: b.areaServed.map((n) => ({ '@type': 'City', name: n })) },
    })),
  };
}

function personSchema(strings) {
  return {
    '@type': 'Person',
    '@id': personId,
    name: b.founderName,
    jobTitle: strings.jobTitle || 'Python Developer',
    email: b.email,
    url: SITE,
    worksFor: { '@id': orgId },
    address: { '@type': 'PostalAddress', addressLocality: b.locality, postalCode: b.postalCode, addressRegion: b.region, addressCountry: b.country },
    knowsLanguage: cfg.langs.map((l) => LANG_NAMES[l]),
    knowsAbout: ['Python', 'FastAPI', 'Flask', 'React', 'Business Software', 'Process Automation'],
    sameAs: [b.linkedin],
  };
}

function websiteSchema() {
  return {
    '@type': 'WebSite',
    '@id': websiteId,
    url: SITE,
    name: b.name,
    publisher: { '@id': orgId },
    inLanguage: cfg.langs.map((l) => cfg.hreflang[l]),
  };
}

function webPageSchema(lang, path, title, description, type) {
  return {
    '@type': type || 'WebPage',
    '@id': `${SITE}${path}#webpage`,
    url: `${SITE}${path}`,
    name: title,
    description,
    inLanguage: cfg.hreflang[lang],
    isPartOf: { '@id': websiteId },
    about: { '@id': orgId },
  };
}

// items: [{ name, url }] after the home crumb
function breadcrumbSchema(lang, homeName, items) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: homeName, item: `${SITE}/${lang}` },
      ...items.map((it, i) => ({ '@type': 'ListItem', position: i + 2, name: it.name, item: it.url })),
    ],
  };
}

function softwareAppSchema(project, url) {
  return {
    '@type': 'SoftwareApplication',
    '@id': `${url}#software`,
    name: project.title,
    description: project.description,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    author: { '@id': orgId },
    image: project.image,
    url,
  };
}

function buildGraph(...nodes) {
  return { '@context': 'https://schema.org', '@graph': nodes };
}

module.exports = { organizationSchema, personSchema, websiteSchema, webPageSchema, breadcrumbSchema, softwareAppSchema, buildGraph };
